<template>
    <ul class="info-box">
        <li class="img-box">
            <img :src="imgSrc" class="material-img">
        </li>

        <li class="text-box">
            <ul class="info">
                <li class="title">
                    {{materialObj.productname}}
                </li>

                <li class="price">
                    ${{materialObj.cost}}{{unit}}
                </li>

                <li class="des">
                    {{materialObj.description}}
                </li>
            </ul>
        </li>
    </ul>
</template>

<script setup>
    import {getCurrentInstance, ref, computed} from 'vue'
    import myUtil from "@/util/util";

    const emits = defineEmits(['logout-complete'])
    const props = defineProps(['materialObj'])

    let { proxy } = getCurrentInstance();

    const imgSrc = computed(() => {
        return myUtil.generateProductImg(props.materialObj)
    })

    const unit = computed(() => {
        let text = ""

        if (null != props.materialObj.unit && "" !== props.materialObj.unit){
            text = ` / ${props.materialObj.unit}`
        }

        return text
    })
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .text-box {
        margin-top: 10%;
    }

    .info-box{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-top: 20%;
        overflow: hidden;
    }

    .img-box {
        width: 80%;
        padding-top: 80%;
        position: relative;
        height: 0;
        margin: auto;
    }

    .img-box .material-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
        position: absolute;
        top: 0;
        left: 0;
    }

    .info {
        font-size: 14px;
        text-align: center;
        line-height: 2;
        padding-left: 10%;
        padding-right: 10%;
        box-sizing: border-box;
    }

    .info .title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .info .price {
        font-weight: 600;
        font-size: 16px;
        color: #e83f33;
    }

    .info .des {
        font-size: 12px;
        color: #666;
    }
</style>